export default __webpack_public_path__ + "static/case02-6a1ac5f084c81acfda02522a78113d56.webp";